import { createOrder } from '../../_meta/order';

export const createReshipOrder = () => {
  const order = createOrder({ addressKey: 'to' });
  delete order.orderItems;
  return order;
};

export default {};
